import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { getSiteUrl, toAbsoluteUrl } from "./siteUrl";

const SITE_NAME = "Fursatook";
const DESCRIPTION_MAX_LENGTH = 160;

function truncateDescription(text) {
  if (!text || text.length <= DESCRIPTION_MAX_LENGTH) return text;
  return `${text.slice(0, DESCRIPTION_MAX_LENGTH - 3).trim()}...`;
}

function SeoHead({
  title,
  description,
  path = "/",
  image,
  noIndex = false,
  jsonLd,
}) {
  const { i18n } = useTranslation();
  const siteUrl = getSiteUrl();
  const canonicalUrl = `${siteUrl}${path.startsWith("/") ? path : `/${path}`}`;
  const metaDescription = truncateDescription(description);
  const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const ogLocale = i18n.language === "ar" ? "ar_SA" : "en_US";
  const ogImage = toAbsoluteUrl(image);

  return (
    <Helmet>
      <title>{pageTitle}</title>
      {metaDescription && <meta name="description" content={metaDescription} />}
      <link rel="canonical" href={canonicalUrl} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:title" content={title || SITE_NAME} />
      {metaDescription && (
        <meta property="og:description" content={metaDescription} />
      )}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content={ogLocale} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || SITE_NAME} />
      {metaDescription && (
        <meta name="twitter:description" content={metaDescription} />
      )}
      <meta name="twitter:image" content={ogImage} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}

export default SeoHead;
